export class CityModalController {
  constructor(controller) {
    this.controller = controller;
  }

  openCityModal(event) {
    event.preventDefault();
    if (this.controller.hasCityModalTarget) {
      this.controller.cityModalTarget.classList.add('is-active');
      this.loadCitiesForPrefecture();
    }
  }

  // 市区町村リストを取得
  async fetchCities(prefectureName) {
    if (prefectureName === '都道府県を選択') return [];

    try {
      const response = await fetch(`/api/prefecture/${prefectureName}/cities`);
      if (!response.ok) return [];
      return await response.json();
    } catch {
      return [];
    }
  }

  // 政令指定都市リストを取得（is_major_cityフラグで抽出）
  async fetchMajorCities(prefectureName) {
    if (prefectureName === '都道府県を選択') return [];

    try {
      const response = await fetch(`/api/prefecture/${prefectureName}/cities_with_major`);
      if (!response.ok) return [];
      const cities = await response.json();
      return cities.filter(city => city.is_major_city);
    } catch {
      return [];
    }
  }

  async loadCitiesForPrefecture() {
    if (!this.controller.formValue.prefecture_name) {
      return;
    }

    if (this.controller.hasPrefectureNameTarget) {
      this.controller.prefectureNameTarget.textContent = this.controller.formValue.prefecture_name;
    }

    if (this.controller.hasCityButtonsContainerTarget) {
      const container = this.controller.cityButtonsContainerTarget;

      // 市区町村と政令指定都市を並行で取得
      const [cities, majorCities] = await Promise.all([
        this.fetchCities(this.controller.formValue.prefecture_name),
        this.fetchMajorCities(this.controller.formValue.prefecture_name)
      ]);

      // 政令指定都市と市区町村をマージ
      const allCities = [...majorCities, ...cities];

      container.innerHTML = '';

      const kanaGroups = [
        { group: 'あ', kanas: ['ア', 'イ', 'ウ', 'エ', 'オ'] },
        { group: 'か', kanas: ['カ', 'キ', 'ク', 'ケ', 'コ', 'ガ', 'ギ', 'グ', 'ゲ', 'ゴ'] },
        { group: 'さ', kanas: ['サ', 'シ', 'ス', 'セ', 'ソ', 'ザ', 'ジ', 'ズ', 'ゼ', 'ゾ'] },
        { group: 'た', kanas: ['タ', 'チ', 'ツ', 'テ', 'ト', 'ダ', 'ヂ', 'ヅ', 'デ', 'ド'] },
        { group: 'な', kanas: ['ナ', 'ニ', 'ヌ', 'ネ', 'ノ'] },
        { group: 'は', kanas: ['ハ', 'ヒ', 'フ', 'ヘ', 'ホ', 'バ', 'ビ', 'ブ', 'ベ', 'ボ', 'パ', 'ピ', 'プ', 'ペ', 'ポ'] },
        { group: 'ま', kanas: ['マ', 'ミ', 'ム', 'メ', 'モ'] },
        { group: 'や', kanas: ['ヤ', 'ユ', 'ヨ'] },
        { group: 'ら', kanas: ['ラ', 'リ', 'ル', 'レ', 'ロ'] },
        { group: 'わ', kanas: ['ワ', 'ヲ', 'ン'] }
      ];

      const kanaGroupData = [];

      kanaGroups.forEach(({ group, kanas }) => {
        const groupCities = allCities.filter(city => {
          if (!city.yomi) return false;
          const firstChar = city.yomi.slice(0, 1);
          return kanas.includes(firstChar);
        });

        if (groupCities.length > 0) {
          kanaGroupData.push({ kana: group, cities: groupCities });
        }
      });

      kanaGroupData.forEach((group) => {
        if (group.cities.length > 0) {
          const groupTitle = document.createElement('div');
          groupTitle.className = 'subsidies-search-panel__modal-city-group-title';
          groupTitle.textContent = `${group.kana}行`;
          container.appendChild(groupTitle);

          group.cities.forEach(city => {
            const button = document.createElement('button');
            button.className = 'subsidies-search-panel__modal-city-button';
            button.type = 'button';
            button.textContent = city.name;
            button.dataset.cityId = city.id;
            button.dataset.cityName = city.name;
            button.dataset.action = 'click->refosumu-subsidies-search-panel#selectCity';

            if (this.controller.formValue.city_name && this.controller.formValue.city_name === city.name) {
              button.classList.add('is-selected');
              if (!this.controller.formValue.city_id) {
                this.controller.formValue.city_id = city.id;
              }
            }

            container.appendChild(button);
          });
        }
      });
    }
  }

  async selectCity(event) {
    const button = event.currentTarget;

    this.controller.cityButtonsContainerTarget.querySelectorAll('.subsidies-search-panel__modal-city-button').forEach(btn => {
      btn.classList.remove('is-selected');
    });

    button.classList.add('is-selected');

    this.controller.formValue = {
      ...this.controller.formValue,
      city_id: button.dataset.cityId || null,
      city_name: button.dataset.cityName || null
    };

    if (this.controller.hasCityConfirmTarget) {
      const confirmButton = this.controller.cityConfirmTarget;
      const messageTarget = this.controller.hasCityNoResultsMessageTarget ? this.controller.cityNoResultsMessageTarget : null;
      await this.controller.updateModalButtonState(confirmButton, messageTarget, '決定する');
    }
  }

  confirmCitySelection(event) {
    event.preventDefault();
    if (this.controller.formValue.city_id) {
      if (this.controller.cityInputTextTarget) {
        this.controller.cityInputTextTarget.textContent = this.controller.formValue.city_name;
      }

      const cityInput = this.controller.element.querySelector('input[name="city_id"]');

      if (cityInput) {
        cityInput.value = this.controller.formValue.city_id || '';
      }
    }

    this.updateCityDisplay();
    this.controller.closeAllModals();
  }

  updateCityDisplay() {
    const displayText = this.controller.formValue.city_name
      ? this.controller.formValue.city_name
      : '指定なし';

    if (this.controller.hasCityInputTextTarget) {
      this.controller.cityInputTextTarget.textContent = displayText;
    }

    if (this.controller.hasCityInputBoxTarget) {
      if (this.controller.formValue.city_name) {
        this.controller.cityInputBoxTarget.classList.add('subsidies-search-panel__input-box--active');
      } else {
        this.controller.cityInputBoxTarget.classList.remove('subsidies-search-panel__input-box--active');
      }
    }
  }
}
